import { User, UserCvProfile } from '@core/generated/gql-types';

export const CANDIDATE_SUMMARY_MAX_LENGTH = 500;

export const CANDIDATE_SUMMARY_AI_DISCLAIMER =
  "This summary has been AI-generated based on the candidate's uploaded resume.";

export const getWorkerCvProfile = (
  worker: User | null | undefined,
): UserCvProfile | null => {
  if (!worker) {
    return null;
  }

  if (worker.cvProfile?.summary) {
    return worker.cvProfile;
  }

  if (worker.profileSummary) {
    return {
      summary: worker.profileSummary,
      priorityEngagementPoints: [],
      isAiGenerated: false,
    };
  }

  return null;
};

export const getWorkerCvSummary = (worker: User | null | undefined): string => {
  return getWorkerCvProfile(worker)?.summary?.trim() || '';
};

export const isWorkerCvSummaryAiGenerated = (
  worker: User | null | undefined,
): boolean => {
  return getWorkerCvProfile(worker)?.isAiGenerated === true;
};

export const getWorkerPriorityEngagementPoints = (
  worker: User | null | undefined,
): string[] => {
  return (
    getWorkerCvProfile(worker)?.priorityEngagementPoints?.filter((point) =>
      Boolean(point?.trim()),
    ) ?? []
  );
};
